import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import { AreaGuard, AuthGuard, FlagGuard, PortalGuard } from "@/components/auth/AuthGuard";
import AppShell from "@/components/layout/AppShell";
import Dashboard from "@/pages/dashboard/page";
import PartnersPage from "@/pages/partners/page";
import PartnerDetailPage from "@/pages/partners/detail/page";
import NewPartnerPage from "@/pages/partners/new/page";
import OnboardingPage from "@/pages/partners/onboarding/page";
import ImportPage from "@/pages/import/page";
import CatalogPage from "@/pages/catalog/page";
import ProductPage from "@/pages/catalog/detail/page";
import SpecificationsPage from "@/pages/specifications/page";
import SpecificationDetailPage from "@/pages/specifications/detail/page";
import PurchaseOrdersPage from "@/pages/purchase-orders/page";
import PurchaseOrderDetailPage from "@/pages/purchase-orders/detail/page";
import StorefrontPage from "@/pages/storefront/page";
import SettingsPage from "@/pages/settings/page";
import FeedbackPage from "@/pages/feedback/page";
import PortalShell from "@/components/portal/PortalShell";
import PortalLoginPage from "@/pages/portal/login/page";
import PortalHomePage from "@/pages/portal/home/page";
import PortalProductsPage from "@/pages/portal/products/page";
import PortalUploadPage from "@/pages/portal/upload/page";
import PortalDemandPage from "@/pages/portal/demand/page";
import PortalReservationsPage from "@/pages/portal/reservations/page";
import PortalOrdersPage from "@/pages/portal/orders/page";
import PortalOrderDetailPage from "@/pages/portal/orders/detail/page";
import PortalFinancePage from "@/pages/portal/finance/page";
import PortalWarrantyPage from "@/pages/portal/warranty/page";
import PortalClaimDetailPage from "@/pages/portal/warranty/detail/page";
import PortalContractPage from "@/pages/portal/contract/page";
import PortalTeamPage from "@/pages/portal/team/page";
import PortalFeedbackPage from "@/pages/portal/feedback/page";

// Разделы фазы 2 (витрина, загрузка прайса партнёром, спрос, гарантия) скрыты фичефлагами workspace_settings — редирект, а не моки.
const routes: RouteObject[] = [
  {
    path: "/portal/login",
    element: <PortalLoginPage />,
  },
  {
    path: "/portal",
    element: (
      <PortalGuard>
        <PortalShell />
      </PortalGuard>
    ),
    children: [
      { index: true, element: <PortalHomePage /> },
      { path: "products", element: <PortalProductsPage /> },
      {
        path: "upload",
        element: (
          <FlagGuard flag="portal_upload" to="/portal">
            <PortalUploadPage />
          </FlagGuard>
        ),
      },
      {
        path: "demand",
        element: (
          <FlagGuard flag="demand" to="/portal">
            <PortalDemandPage />
          </FlagGuard>
        ),
      },
      { path: "reservations", element: <PortalReservationsPage /> },
      { path: "orders", element: <PortalOrdersPage /> },
      { path: "orders/:poNumber", element: <PortalOrderDetailPage /> },
      { path: "finance", element: <PortalFinancePage /> },
      {
        path: "warranty",
        element: (
          <FlagGuard flag="warranty_ui" to="/portal">
            <PortalWarrantyPage />
          </FlagGuard>
        ),
      },
      {
        path: "warranty/:claim",
        element: (
          <FlagGuard flag="warranty_ui" to="/portal">
            <PortalClaimDetailPage />
          </FlagGuard>
        ),
      },
      { path: "contract", element: <PortalContractPage /> },
      { path: "team", element: <PortalTeamPage /> },
      { path: "feedback", element: <AreaGuard area="feedback"><PortalFeedbackPage /></AreaGuard> },
      { path: "*", element: <NotFound /> },
    ],
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <AppShell />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <AreaGuard area="dashboard"><Dashboard /></AreaGuard> },
      { path: "partners", element: <AreaGuard area="partners"><PartnersPage /></AreaGuard> },
      { path: "partners/new", element: <AreaGuard area="partners"><NewPartnerPage /></AreaGuard> },
      { path: "partners/:id", element: <AreaGuard area="partners"><PartnerDetailPage /></AreaGuard> },
      { path: "partners/:id/onboarding", element: <AreaGuard area="partners"><OnboardingPage /></AreaGuard> },
      { path: "import", element: <AreaGuard area="import"><ImportPage /></AreaGuard> },
      { path: "catalog", element: <AreaGuard area="catalog"><CatalogPage /></AreaGuard> },
      { path: "catalog/:sku", element: <AreaGuard area="catalog"><ProductPage /></AreaGuard> },
      { path: "specifications", element: <AreaGuard area="specifications"><SpecificationsPage /></AreaGuard> },
      { path: "specifications/:id", element: <AreaGuard area="specifications"><SpecificationDetailPage /></AreaGuard> },
      { path: "purchase-orders", element: <AreaGuard area="purchase_orders"><PurchaseOrdersPage /></AreaGuard> },
      { path: "purchase-orders/:poNumber", element: <AreaGuard area="purchase_orders"><PurchaseOrderDetailPage /></AreaGuard> },
      {
        path: "storefront",
        element: (
          <FlagGuard flag="storefront" to="/">
            <StorefrontPage />
          </FlagGuard>
        ),
      },
      { path: "feedback", element: <FeedbackPage /> },
      { path: "settings", element: <AreaGuard area="settings"><SettingsPage /></AreaGuard> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;
